module.exports = __webpack_public_path__ + "img/logo-for-animation.f894c95e289e773b592004b197a5aa53.svg";